// src/core/adapters/LondonVisualiserStops.js
//
// Stop ordering and index mapping for the visualiser.
// The type grouping and sort directions are arranged so the outbound
// and inbound lanes read as a continuous loop.

import { compareStops } from './LondonDataSort';

const ascending = (a, b) => compareStops(a, b);
const descending = (a, b) => compareStops(b, a);

export const orderStopsForLane = (stops, direction) => {
  const list = Array.isArray(stops) ? stops : [];

  if (direction === 'outbound') {
    const t3 = list.filter(s => s.type === 3).sort(ascending);
    const t1 = list.filter(s => s.type === 1).sort(descending);
    const t2 = list.filter(s => s.type === 2).sort(descending);
    return [...t3, ...t1, ...t2];
  }

  const t2 = list.filter(s => s.type === 2).sort(ascending);
  const t1 = list.filter(s => s.type === 1).sort(ascending);
  const t3 = list.filter(s => s.type === 3).sort(descending);
  return [...t2, ...t1, ...t3];
};

// Outbound keeps the max index per naptan, inbound keeps the min.
export const buildStopIndexMap = (orderedStops, direction) => {
  const map = new Map();
  orderedStops.forEach((s, idx) => {
    if (s?.type === 1 && s?.naptan_id) {
      const key = String(s.naptan_id).trim().toUpperCase();
      if (direction === 'outbound') {
        if (!map.has(key) || idx > map.get(key)) map.set(key, idx);
      } else {
        if (!map.has(key) || idx < map.get(key)) map.set(key, idx);
      }
    }
  });
  return map;
};